import dateFormat from 'dateformat';

const formatDate = (value) => (value ? dateFormat(new Date(value), "dd/mm/yyyy HH:MM:ss") : '');

const statusColor = {
    READ: '#1f9d55',
    DELIVERED: '#2b6cb0',
    SENT: '#805ad5',
    ERROR: '#e02424'
};

const setColumns = () => {

    return [
        {
            id: "checkbox",
            visible: false,
            pinned: false,
            width: "54px",
        },
        {
            id: "templateName",
            field: "templateName",
            label: "Template Name",
            width: '220px',
            sortable: false,
            resizable: true,
        },
        {
            id: "status",
            field: "status",
            label: "Status",
            width: '110px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => (
                <span style={{ color: statusColor[data.status] || 'inherit', fontWeight: 'bold' }}>
                    {data.status}
                </span>
            )
        },
        {
            id: "userId",
            field: "userId",
            label: "User ID",
            width: '150px',
            sortable: false,
            resizable: true,
        },
        {
            id: "providerId",
            field: "idProspect",
            label: "Provider ID",
            width: '150px',
            sortable: false,
            resizable: true,
        },
        {
            id: "sentTime",
            field: "sentTime",
            label: "Sent Time",
            width: '160px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => formatDate(data.sentTime)
        },
        {
            id: "deliveredTime",
            field: "deliveredTime",
            label: "Delivered Time",
            width: '160px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => formatDate(data.deliveredTime)
        },
        {
            id: "readTime",
            field: "readTime",
            label: "Read Time",
            width: '160px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => formatDate(data.readTime)
        },
        {
            id: "responseTime",
            field: "responseTime",
            label: "Response Time",
            width: '160px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => formatDate(data.responseTime)
        },
        {
            id: "errorTime",
            field: "errorTime",
            label: "Error Time",
            width: '160px',
            sortable: false,
            resizable: true,
            cellRenderer: ({ data }) => formatDate(data.errorTime)
        },
        {
            id: "responseMessageText",
            field: "responseMessageText",
            label: "Response Message",
            width: '260px',
            sortable: false,
            resizable: true,
        }
    ];
};

export default setColumns;
